import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=34c5556e&scoped=true&"
import script from "./Kontakt.vue?vue&type=script&lang=ts&"
export * from "./Kontakt.vue?vue&type=script&lang=ts&"
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=34c5556e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5556e",
  null
  
)

export default component.exports